import * as UIActions from '../actionTypes/ui';
import { getDateFnLocale } from '../utils/i18n';
import { DEFAULT_LOCALE } from '../constants/i18n';

export function updateText(props) {
    return {
        type: UIActions.UPDATE_UI_TEXT,
        text: props,
    };
}

export function setConnectNotificationAllowed(isConnectNotificationAllowed) {
    return {
        type: UIActions.SET_CONNECT_NOTIFICATION_ALLOWED,
        isConnectNotificationAllowed,
    };
}

export function resetUI() {
    return {
        type: UIActions.RESET_UI,
    };
}

export function setIsAtBottom(isAtBottom) {
    return {
        type: UIActions.SET_IS_AT_BOTTOM,
        isAtBottom,
    };
}

export function setLocale(locale) {
    return (dispatch) => {
        const actualLocale = getDateFnLocale(locale);

        let promise;

        const getDefaultLocale = () => {
            // TODO [JEST]: continue investigating why DEFAULT_LOCALE is undefined
            const defaultLocale = DEFAULT_LOCALE;
            return import('date-fns/locale/' + `${defaultLocale}` + '/index.js').then((dateFnLocale) => {
                return { actualLocale, dateFnLocale };
            });
        };

        // Load anything related to i18n here (moment locale files, translations, etc.)
        if (actualLocale !== DEFAULT_LOCALE) {
            promise = import('date-fns/locale/' + `${actualLocale}` + '/index.js')
                .then((dateFnLocale) => {
                    return { actualLocale, dateFnLocale };
                })
                .catch(() => getDefaultLocale());
        } else {
            promise = getDefaultLocale();
        }

        promise.then(({ actualLocale, dateFnLocale }) => {
            return dispatch({
                type: UIActions.SET_LOCALE,
                locale: actualLocale,
                dateFnLocale,
            });
        });

        return promise;
    };
}
